export default __webpack_public_path__ + "static/media/removeEffect.22c922b5.mp3";